import type { Components, Theme } from "@mui/material";
import { SvgIcon, useTheme } from "@mui/material";

function UncheckedIcon() {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 24 24">
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="4"
        fill={theme.palette.common.white}
        stroke={theme.palette.custom.border}
        strokeWidth="2"
      />
    </SvgIcon>
  );
}

function CheckedIcon() {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 24 24">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="4"
        fill={theme.palette.custom.fill}
      />
      <path
        d="M16.5 9.5 10.5 15.5 7.5 12.5"
        fill="none"
        stroke={theme.palette.common.white}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

function IndeterminateIcon() {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 24 24">
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="4"
        fill={theme.palette.custom.fill}
      />
      <path
        d="M8 12H16"
        fill="none"
        stroke={theme.palette.common.white}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}

export const checkboxTheme: Components<Theme>["MuiCheckbox"] = {
  defaultProps: {
    icon: <UncheckedIcon />,
    checkedIcon: <CheckedIcon />,
    indeterminateIcon: <IndeterminateIcon />,
  },
};
